export const CommonConstant = {
	user: "user",
	token: "token",
	tenant: "tenant",
	defaultPageSize: 10,
	phoneRegExp: /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,

	defaultVideo: "https://bitdash-a.akamaihd.net/content/MI201109210084_1/m3u8s/f08e80da-bf1d-4e3d-8899-f0f6155f6efa.m3u8"
};


export const ErrorMessages = {
	default: 'Something went wrong, please contact administrator.',
	badCredentials: 'Invalid username and/or password.'
}

export const PaymentType = {
	pack: 'pack',
	card: "card"
}

export const Roles = {
	marketplace: "R_MARKET",
	sellCard: "R_SELL_CARD",
	cashout: "R_CASH_OUT"
}


export const TransactionStatus = {
	success: "SUCCESS",
	fail: "FAIL",
	pending: "PENDING",
	crypto_waiting: "WAITING_FOR_CRYPTO_CHARGE_CONFIRMATION"
}


export const CardAssetTypes = {
	image: 'IMAGE',
	stream: 'STREAM',
	video: 'VIDEO',
	illustration: 'ILLUSTRATION',
	text: 'TEXT'
}